import { post, del } from '../services/jsonfetchservice.js';

export default {
    name: 'finnboxservice',
    dependencies: ['userservice'],
    callable(userservice) {
        const baseUrl = '/finnboks/';
        const replyUrl = 'messages.html';
        return {
            sendReply,
            deleteConversations,
            getNumberOfUnreadMessages,
        };

        function getNumberOfUnreadMessages() {
            return userservice
                .getAccountData()
                .then(
                    accountData =>
                        accountData.loggedIn
                            ? accountData.myMessages.unreadCount
                            : 0
                );
        }

        function sendReply(replyData, callback) {
            return post(baseUrl + replyUrl, replyData)
                .then(() => {
                    callback({ success: true });
                })
                .catch(() => {
                    callback({ success: false });
                });
        }

        function deleteConversations(conversationIds, callback) {
            const result = {
                deleteSuccess: 0,
                deleteFailure: 0,
                deletedConversationIds: [],
            };
            return Promise.all(
                conversationIds.map(conversationId => {
                    const url = `${baseUrl}conversations/${conversationId}.html`;
                    return del(url)
                        .then(() => {
                            result.deleteSuccess++;
                            result.deletedConversationIds.push(conversationId);
                            maybeDone();
                        })
                        .catch(() => {
                            result.deleteFailure++;
                            maybeDone();
                        });
                })
            );

            function maybeDone() {
                if (
                    result.deleteSuccess + result.deleteFailure ===
                    conversationIds.length
                ) {
                    done();
                }
            }

            function done() {
                if (callback) {
                    callback(result);
                }
            }
        }
    },
};



// WEBPACK FOOTER //
// ./services/finnboxservice.js